import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { IProduct, IProductEdp } from './IProduct';
import Portal from '../common/portal';

export interface PdpProps {
    SelectedEdpItem: IProductEdp;
    ProductData: IProduct;
    isAutoDeliveryEnabled: boolean;
    Selector?: any;
}
//const domNode = document.getElementById('lblProductName');
//domNode.innerHTML = '';
const PdpName = ({ SelectedEdpItem, ProductData, isAutoDeliveryEnabled, Selector }: PdpProps) => {
    const {
        Name,
        ItemNo,
        DefaultEdp,
        IsSoldOut,
        DeliveryOptions,
        IsPriceRange,
        WasPriceRange,
        ProductReviewCount,
        ProductReviewRating,
        Styles = [],
        Sizes = [],
        AvailableSwatches,
        Edps,
        Brand,
        BrandDimensionId,
        BadgeImagePath,
        ProductTypePath,
    } = ProductData;

    const productName = useMemo(() => {
        if (isAutoDeliveryEnabled) {
            return DeliveryOptions.find((item) => item.EdpNo == SelectedEdpItem.EdpNo).DisplayName;
        } else {
            return Name;
        }
    }, [DeliveryOptions, SelectedEdpItem, Name, isAutoDeliveryEnabled]);

    if (!Selector) {
        return <>{productName}</>;
    }
    return <Portal selector={Selector}>{productName}</Portal>;
};

export default React.memo(PdpName);
